import { ARROW_CLOSE_ENVELOPE } from 'constants/envelopeIcons';
import moment from 'moment';
import React, { useState } from 'react';
import { AuditLogBatch } from 'selectors/cohorts';
import AuditLogNestedList from './AuditLogNestedList';

type ComponentProps = {
  auditLogBatch: AuditLogBatch;
};

const CohortAuditLogsListItem: React.FC<ComponentProps> = ({ auditLogBatch }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleIsOpen = (): void => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <tr className="row-hover table-row border-t border-gray-200 align-middle">
        <td className="table-wrapper__new-td pl-0">
          <div className="h-15 m-0 pl-0 p-0 flex flex-row justify-center items-center">
            <button
              type="button"
              className="w-full flex flex-row justify-center items-center focus:outline-none"
              onClick={(e): void => {
                e.stopPropagation();
                toggleIsOpen();
              }}
            >
              <span
                className={`w-4 focus:outline-none transition-transform duration-300 ${
                  isOpen && 'transform rotate-90'
                }`}
              >
                {ARROW_CLOSE_ENVELOPE()}
              </span>
            </button>
          </div>
        </td>

        <td className="table-wrapper__new-td">
          <div className="table-wrapper__new-cell-content h-auto m-0 p-0 flex text-body">
            <div className="">
              <span>{moment(auditLogBatch.date).format('MM/DD/YYYY')}</span>
            </div>
          </div>
        </td>

        <td className="table-wrapper__new-td">
          <div className="table-wrapper__new-cell-content h-auto m-0 p-0 flex text-body">
            <span>{auditLogBatch.insightAssigned}</span>
          </div>
        </td>

        <td className="table-wrapper__new-td">
          <div className="table-wrapper__new-cell-content h-auto m-0 p-0 flex text-body">
            <span>{auditLogBatch.preventAssigned}</span>
          </div>
        </td>

        <td className="table-wrapper__new-td">
          <div className="table-wrapper__new-cell-content h-auto m-0 p-0 flex text-body">
            <span>{auditLogBatch.insightTransfers}</span>
          </div>
        </td>

        <td className="table-wrapper__new-td">
          <div className="table-wrapper__new-cell-content h-auto m-0 p-0 flex text-body">
            <span>{auditLogBatch.preventTransfers}</span>
          </div>
        </td>

        <td className="table-wrapper__new-td pl-0">
          <div className="table-wrapper__new-cell-content h-auto m-0 p-0 flex text-body items-center">
            <div className="text-left text-body clamped-text-2 overflow-hidden">Notes</div>
          </div>
        </td>
      </tr>
      {isOpen && <AuditLogNestedList items={auditLogBatch.auditLogs} />}
    </>
  );
};

export default CohortAuditLogsListItem;
